import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import {
    EditorTrafficJamRateCorrectionCondition,
    RateControlValue,
    RateCorrectionConditionChooserItemsGroup,
    RateCorrectionConditionId,
    RateCorrectionType,
    TrafficJamRateCorrectionsType
} from '../../../typings/ratesCorrections';
import { RateControl } from '../../RateControl/RateControl';
import { RateCorrectionConditionChooserView } from '../../RateCorrectionConditionChooser/RateCorrectionConditionChooser';
import { RateCorrectionConditionSelector } from '../../RateCorrectionConditionSelector/RateCorrectionConditionSelector';

import './RatesCorrectionsListTrafficJamCondition.css';

export type onChangeTrafficJamConditionParams = {
    type: RateCorrectionType.trafficJam;
    value: EditorTrafficJamRateCorrectionCondition;
    id: RateCorrectionConditionId;
};

export interface RatesCorrectionsListTrafficJamConditionProps {
    value: EditorTrafficJamRateCorrectionCondition;
    maxRate?: number;
    minRate?: number;
    chooserData: Array<RateCorrectionConditionChooserItemsGroup>;
    disabledChooserDataItems: Array<string>;
    isHiddenRateControl?: boolean;
    onChange: (params: onChangeTrafficJamConditionParams) => void;
}

const blockClass = 'rates-corrections-list-traffic-jam-condition';

export class RatesCorrectionsListTrafficJamCondition extends React.PureComponent<
    RatesCorrectionsListTrafficJamConditionProps
> {
    render() {
        const { chooserData, value, minRate, maxRate, disabledChooserDataItems } = this.props;

        return (
            <div className={blockClass}>
                <RateCorrectionConditionSelector
                    view={RateCorrectionConditionChooserView.default}
                    cls={classNames(Bem.cls(blockClass, 'selector'), Bem.cls(blockClass, value.trafficJamType))}
                    value={[value.trafficJamType]}
                    items={chooserData}
                    disabledItems={disabledChooserDataItems}
                    onChange={this.onRateCorrectionConditionChooserChange}
                />
                <RateControl
                    cls={Bem.cls(blockClass, 'rate')}
                    value={value.value}
                    max={maxRate}
                    min={minRate}
                    isCommon={false}
                    errors={value.errors.value}
                    onChange={this.onRateControlChange}
                />
            </div>
        );
    }

    private onRateCorrectionConditionChooserChange = (values: Array<string>) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.trafficJam,
            id: value.id,
            value: {
                ...value,
                trafficJamType: values[0] as TrafficJamRateCorrectionsType
            }
        });
    };

    private onRateControlChange = (rate: RateControlValue) => {
        const { value, onChange } = this.props;

        onChange({
            type: RateCorrectionType.trafficJam,
            id: value.id,
            value: {
                ...value,
                value: rate
            }
        });
    };
}
